// El numero con el que un jugador juega EN ESTE GRUPO: el del grupo si se le puso uno
// (jugadores_grupos.numero_jersey), si no el del club (jugadores.numero). Es la misma
// regla que ya usan los pedidos de uniforme (numeroEfectivo); el tarjeton imprimia
// siempre el del club y se saltaba el del grupo (el dueno, 2026-09-07).
export function numeroEnGrupo(jugadorGrupo = {}, jugador = {}) {
  const enGrupo = jugadorGrupo?.numero_jersey
  if (enGrupo !== null && enGrupo !== undefined && String(enGrupo).trim() !== '') return String(enGrupo)
  const club = jugador?.numero
  if (club !== null && club !== undefined && String(club).trim() !== '') return String(club)
  return ''
}

// Validacion pura de numeros de camiseta de un grupo.
// numeros: array de valores (string|number|null). Devuelve:
//   repetidos: Set de numeros (string) que aparecen 2+ veces (no vacios).
//   faltantes: cuantos vienen vacios.
export function detectarNumeros(numeros = []) {
  const norm = numeros.map((n) => (n == null ? '' : String(n).trim()));
  const faltantes = norm.filter((n) => n === '').length;
  const counts = {};
  norm.forEach((n) => { if (n !== '') counts[n] = (counts[n] || 0) + 1; });
  const repetidos = new Set(Object.keys(counts).filter((k) => counts[k] > 1));
  return { repetidos, faltantes };
}
